import colors from "colors";
import { IconProps } from "./types";

export default function IcoLogout({
	color = colors.neutral["low-300"],
	size = "24"
}: Readonly<IconProps>) {
	return (
		<svg
			width={size}
			height={size}
			viewBox={`0 0 ${size} ${size}`}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9 12H21M21 12L15.6 18M21 12L15.6 6M9 21H3V3H9"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
